import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../Landingpage/Subcomponents/Header";
import PricingSection from "../../shared/Pricing/PricingSection";

const Pricing = ({ currentLanguage, setCurrentLanguage }) => {
  const { t } = useTranslation();

  return (
    <Header currentLanguage={currentLanguage} setCurrentLanguage={setCurrentLanguage}>
      <Container style={{ paddingTop: 48, paddingBottom: 64 }}>
        <Row className="justify-content-center mb-4">
          <Col lg={6} className="text-center">
            <h2 style={{ fontWeight: 800, color: "#1a1f2e" }}>{t("Plans.Header")}</h2>
          </Col>
        </Row>
        <PricingSection ctaHref="/signup" />
      </Container>
    </Header>
  );
};

export default Pricing;
